export default function init() {
  if (window.snowhistPage) return import(/* webpackChunkName: "d3_snowhist" */ "./snowhist")

  return false
}
